import React, { Component } from "react";
import "./Footer.css";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
class Footer extends Component {
  render() {
    return (
      <>
        <footer id="footer">
          <div className="container">
            <div className="row d-flex align-items-center">
              <div className="col-lg-6 text-lg-left">
                <div className="row justify-content-center">
                  <div className="col-sm-6">
                    <div className="copyright">
                      <h3 style={{ color: "#fff" }}>GivBee </h3>
                      <p>
                        <span>
                          <i className="fa fa-phone" />
                          &nbsp; (844)407-1996
                        </span>{" "}
                        &nbsp;
                        <span>
                          {" "}
                          <i className="fa fa-envelope" />
                          &nbsp; support@givbee.com
                        </span>
                      </p>
                      Copyright (c) 2025 &nbsp;<strong>GivBee</strong>, LLC. All
                      rights reserved.
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <nav className="footer-links text-lg-right text-center pt-2 pt-lg-0">
                  <a
                    href="/faqs"
                    className="scrollto"
                    style={{ color: "#fff" }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    FAQs
                  </a>
                  <a
                    href="/privacy-policy"
                    style={{ color: "#fff" }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                  <a
                    href="/terms-conditions"
                    style={{ color: "#fff" }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms of Service
                  </a>
                </nav>
                <div className="social-links" id="footerIcon">
                  <a
                    href="https://twitter.com/Giv_Bee"
                    className="twitter"
                    target="_blank"
                  >
                    <TwitterIcon />
                  </a>
                  <a
                    href="https://www.facebook.com/GivBee1"
                    className="facebook"
                    target="_blank"
                  >
                    <FacebookIcon />
                  </a>

                  <a
                    href="https://www.linkedin.com/company/givbee"
                    className="linkedin"
                    target="_blank"
                  >
                    <LinkedInIcon />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </>
    );
  }
}

export default Footer;
